// extracted by mini-css-extract-plugin
export default {"container":"SelectSection-module__container--NlrfH","selectors":"SelectSection-module__selectors--3VtYY"};